"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackWishlistError = exports.WishlistError = void 0;
const enums_1 = require("../enums");
const trackAnalyticsEvent_1 = require("./trackAnalyticsEvent");
var WishlistError;
(function (WishlistError) {
    WishlistError["ItemWentOffline"] = "Item went offline";
    WishlistError["MoreThan99Products"] = "More than 99 products";
})(WishlistError || (exports.WishlistError = WishlistError = {}));
const trackWishlistError = (error, message) => {
    const eventData = {
        eventName: enums_1.GA4EventName.ShowNotification,
        feature_category: enums_1.GA4FeatureCategory.Wishlist,
        notification_type: error === WishlistError.ItemWentOffline
            ? 'Error - Product went offline'
            : 'Error - More than 99 products in wishlist',
        notification_message: message,
    };
    (0, trackAnalyticsEvent_1.trackAnalyticsEvent)({
        category: enums_1.EventCategory.Wishlist,
        action: enums_1.EventAction.Error,
        label: error,
        nonInteraction: true,
        eventData,
    });
};
exports.trackWishlistError = trackWishlistError;
//# sourceMappingURL=trackWishlistError.js.map